import React, { useContext } from "react";
import Switch from "../switch";
import Img from "gatsby-image";
import styled from "styled-components";
import { ProductContext } from "../product-context";
import Wrapper from "../../layout/Wrapper";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import breakpoint from 'styled-components-breakpoint'
import "../animaciones-producto.css";

const GrayBgContainer = styled.div`
  background: ${props => props.theme.colors.grisDeFondo};
  padding: ${props => props.theme.space[5]}px 0;
  position: relative;
  padding-right: 180px;
  margin-top:30px;

  ${breakpoint('tablet')`
  margin-top:0px !important;
`}

  @media screen and (min-width: ${p => p.theme.breakpoints[1]}px) {
    position: static;
    padding-right: 0;
  }

  p {
    margin: 0;
    line-height: 1.5em;
    font-size: 18px;
  }

  a {
    color: ${p => p.theme.colors.rojoBac};
    text-decoration: none;

    &:hover,
    &:hover:after {
      color: ${p => p.theme.colors.rojoOscuro};
      border-color: transparent transparent transparent
        ${p => p.theme.colors.rojoOscuro};
    }

    :after {
      content: "";
      display: inline-block;
      margin-left: 5px;
      margin-bottom: -1px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 6px 0 6px 12px;
      border-color: transparent transparent transparent
        ${p => p.theme.colors.rojoBac};
    }
  }
`;

const FirstSection = styled(Wrapper)`
  padding-top: ${props => props.theme.space[2]}px;
`;

const SwitchContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(150px, 242px) minmax(100px, 200px);
  margin-bottom: -10px;
  z-index: 2;

  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 2;
  }
`;

const HeroCardImageContainer = styled.div`
  max-width: 242px;
  position: relative;
  padding-top: 62.5%;

  & > div {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
  }

  .tarjeta-animation-container {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;

    background: ${props => props.theme.colors.grisDeFondo};
    box-shadow: ${props => props.theme.shadows[1]};
    border-radius: 11px;
    overflow: hidden;

    transition: transform 0.3s ease, opacity 0.3s ease;
  }
`;

const HeroImageContainer = styled.div`
  position: absolute;
  width: 180px;
  right: 0;
  bottom: 0;
  top: 0;
  background: ${props => props.theme.colors.grisDeFondo};

  .gatsby-image-wrapper {
    min-height: 100%;
  }

  @media screen and (min-width: ${p => p.theme.breakpoints[1]}px) {
    width: 50vw;

    .gatsby-image-wrapper {
      min-height: none;
    }
  }
`;

const HeroInfo = styled.div`
  max-width: 450px;
`

export default ({ variaciones, hero: {imagen, titular, subTitular} }) => {
  const { selectedColorKey } = useContext(ProductContext);
  const producto = variaciones[selectedColorKey];

  return (
    <div
      className="testing"
      style={{ position: `relative`, overflow: `hidden` }}
    >
      <FirstSection>
        <h1>
          Tarjeta {producto.producto}
          <br />
          <small>De BAC Credomatic</small>
        </h1>
        <SwitchContainer>
          <HeroCardImageContainer>
            <TransitionGroup>
              <CSSTransition
                key={producto.id}
                timeout={150}
                classNames="tarjeta"
              >
                <div className="tarjeta-animation-container" key={producto.id}>
                  <Img fluid={producto.arte.fluid} alt={producto.producto} />
                </div>
              </CSSTransition>
            </TransitionGroup>
          </HeroCardImageContainer>
          <Switch id="hero" {...{ variaciones }} />
        </SwitchContainer>
      </FirstSection>
      <GrayBgContainer>
        <Wrapper>
          <HeroInfo className="hero-info" style={{ gridArea: `info` }}>
            <p>
              <strong>{titular}</strong>
            </p>
            <p>
              {subTitular}
            </p>
          </HeroInfo>
        </Wrapper>
        <HeroImageContainer>
          <Img sizes={imagen.fluid} alt={titular} />
        </HeroImageContainer>
      </GrayBgContainer>
    </div>
  );
};